import {basicContext} from "../../../utils/contextUtils";
import Errors from "../../../utils/Errors";
import moment from "moment";
import async from "async";

export const entity = {
    name: 'Currency',
    fields: [
        {path: 'symbol', unique: true},
        {path: 'abbreviation', unique: true},
        {path: 'nature', type: 'Nature'},
    ],
    firstCurrencyIsReferenceCurrency: function(newObject, oldObject, context, callback) {
        if (newObject.nature.id !== '2') return callback()

        global.app.SE.Currency.find({
                ...basicContext(context),
                fieldPath: [],
                query: {}
            },
            (err, results) => {
                if (err) return callback(err);

                // Si c'est la toute première devise créée, elle doit être "reference"
                if (results.length === 0) return callback(new Errors.ValidationError(context.tc("firstCurrencyIsReferenceCurrencyError The first created currency must be the reference currency.")))

                callback();
            }
        );
    },
    onlyOneReferenceCurrency: function(newObject, oldObject, context, callback) {
        if (newObject.nature.id !== '1') return callback()

        global.app.SE.Currency.find({
                ...basicContext(context),
                fieldPath: [],
                query: {
                    _id: { $ne: new global.ObjectID(newObject.id) }, // exclure l'objet en cours de sauvegarde
                    nature: '1'
                }
            },
            (err, results) => {
                if (err) return callback(err);

                if (results.length > 0) return callback(new Errors.ValidationError(context.tc("onlyOneReferenceCurrencyError Only one reference currency is allowed")))

                callback();
            }
        );
    },
    validateSave: function(newObject, oldObject, context, callback) {
        async.series([
            callback => this.firstCurrencyIsReferenceCurrency(newObject, oldObject, context, callback),
            callback => this.onlyOneReferenceCurrency(newObject, oldObject, context, callback)
        ], callback)
    },
    filters: [
        {
            name: 'isReferenceCurrency',
            isDefault: false,
            query: function() {
                return {"nature": "1"}
            }
        },
    ]
}


export const module_ = {
    object: 'Currency',
    category: {
        path: 'paramétrage',
        icon: 'settings'
    },
    //tKey: '',
    defaultSortBy: 'abbreviation',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'symbol'},
            {path: 'abbreviation'},
            {path: 'nature'}
        ],
        form: [
            {path: 'symbol', editable: false, required: true},
            {path: 'abbreviation', required: true},
            {path: 'nature', type: 'toggle', editable: false},
        ],
    }
}

